module.exports = __webpack_public_path__ + "static/hackathon-logo-inspiration-8de0e69ece7ace00f4fcd698380fcdbb.jpeg";